import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

export default function ModalDynamic({
    show,
    accion,
    title,
    columns,
    formData,
    errors,
    onChange,
    onSubmit,
    onClose,
    loading = false,
    size = "lg"
}) {
    const modalTitle = {
        crear: `Crear ${title}`,
        editar: `Editar ${title}`,
        consultar: `Consultar ${title}`
    }[accion];

    // Filtramos las columnas que sí son inputs
    const filteredCols = columns.filter(col => col.key !== 'index');
    const inputsCount = filteredCols.length;

    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            size={size}
            backdrop="static"
            className="modal-custom"
            backdropClassName="custom-backdrop"
            dialogClassName="modal-custom-dialog"
        >
            <Modal.Header closeButton className="bg-light border-0">
                <Modal.Title className="h5 mb-0">{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-white p-3">
                {loading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Cargando...</span>
                        </div>
                        <span className="ms-2">Cargando datos...</span>
                    </div>
                ) : (
                    <Form onSubmit={e => { e.preventDefault(); onSubmit(); }}>
                        <Row>
                            {filteredCols.map((col, idx) => {
                                const isSoloEnFila = inputsCount % 2 === 1 && idx === inputsCount - 1;
                                const colSize = isSoloEnFila ? 12 : 6;
                                let rawValue = formData[col.key];
                                // Si hay función render y estamos en modo consultar, aplicarla
                                let displayValue = rawValue;
                                if (col.render && typeof col.render === 'function' && accion === 'consultar') {
                                    displayValue = col.render(rawValue);
                                }
                                // Si está undefined o null, mostrar cadena vacía
                                if (displayValue === undefined || displayValue === null) {
                                    displayValue = '';
                                }
                                // Para inputs editables, usar el valor raw
                                const inputValue = accion === 'consultar' ? displayValue : (rawValue || '');

                                return (
                                    <Col key={col.key} md={colSize} className="mb-2">
                                        <Form.Group controlId={`form${col.key}`} className="mb-1">
                                            <Form.Label className="fw-medium small">
                                                {col.label}
                                            </Form.Label>
                                            {col.options ? (
                                                <Form.Select
                                                    size="sm"
                                                    name={col.key}
                                                    value={String(rawValue ?? '')}
                                                    onChange={onChange}
                                                    disabled={accion === 'consultar' || col.disabled}
                                                    isInvalid={!!errors[col.key]}
                                                >
                                                    <option value="">Seleccione…</option>
                                                    {col.options.map(o => (
                                                        <option key={String(o.value)} value={String(o.value)}>
                                                            {o.label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            ) : col.as === 'textarea' ? (
                                                <Form.Control
                                                    as="textarea"
                                                    size="sm"
                                                    name={col.key}
                                                    placeholder={col.label}
                                                    value={String(inputValue)}
                                                    onChange={onChange}
                                                    disabled={accion === 'consultar' || col.disabled}
                                                    isInvalid={!!errors[col.key]}
                                                    style={{
                                                        resize: 'none', 
                                                        overflow: 'hidden' 
                                                    }}
                                                    rows={1} 
                                                />
                                            ) : col.type === 'time' ? (
                                                <div className="d-flex align-items-center">
                                                    {/* Selector de hora (00–23) */}
                                                    <Form.Select
                                                        size="sm"
                                                        name={col.key}
                                                        value={(rawValue || '00:00').split(':')[0]}
                                                        onChange={e => {
                                                            const [, minute] = (rawValue || '00:00').split(':');
                                                            onChange({
                                                                target: {
                                                                    name: col.key,
                                                                    value: `${e.target.value}:${minute}`
                                                                }
                                                            });
                                                        }}
                                                        disabled={accion === 'consultar' || col.disabled}
                                                        isInvalid={!!errors[col.key]}
                                                        className="me-1"
                                                    >
                                                        {[...Array(24)].map((_, i) => {
                                                            const h = String(i).padStart(2, '0');
                                                            return (
                                                                <option key={h} value={h}>
                                                                    {h}
                                                                </option>
                                                            );
                                                        })}
                                                    </Form.Select>

                                                    <span className="mx-1">:</span>

                                                    {/* Selector de minuto (00–59) */}
                                                    <Form.Select
                                                        size="sm"
                                                        name={col.key}
                                                        value={(rawValue || '00:00').split(':')[1]}
                                                        onChange={e => {
                                                            const [hour] = (rawValue || '00:00').split(':');
                                                            onChange({
                                                                target: {
                                                                    name: col.key,
                                                                    value: `${hour}:${e.target.value}`
                                                                }
                                                            });
                                                        }}
                                                        disabled={accion === 'consultar'}
                                                        isInvalid={!!errors[col.key]}
                                                    >
                                                        {[...Array(60)].map((_, i) => {
                                                            const m = String(i).padStart(2, '0');
                                                            return (
                                                                <option key={m} value={m}>
                                                                    {m}
                                                                </option>
                                                            );
                                                        })}
                                                    </Form.Select>
                                                </div>
                                            ) : (
                                                <Form.Control
                                                    size="sm"
                                                    type={col.type || 'text'}
                                                    name={col.key}
                                                    placeholder={col.label}
                                                    value={String(inputValue)}
                                                    onChange={onChange}
                                                    disabled={accion === 'consultar' || col.disabled}
                                                    isInvalid={!!errors[col.key]}
                                                />
                                            )}
                                            <Form.Control.Feedback type="invalid" className="small">
                                                {errors[col.key]}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                );
                            })}
                        </Row>
                    </Form>
                )}
            </Modal.Body>
            <Modal.Footer className="border-0">
                <Button variant="outline-secondary" size="sm" onClick={onClose}>
                    Cerrar
                </Button>
                {accion !== 'consultar' && !loading && (
                    <Button variant="primary" size="sm" onClick={onSubmit}>
                        {accion === 'crear' ? 'Guardar' : 'Actualizar'}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
}